<div class="avatar" [class.avatar--sm]="size === 'sm'" [class.avatar--md]="size === 'md'" [class.avatar--lg]="size === 'lg'" [class.avatar--editable]="editable">
  @if (photo) {
    <img class="avatar__img" [src]="photo" alt="" />
  } @else {
    <div class="avatar__initials" [style.background-color]="backgroundColor">
      <span>{{ initials }}</span>
    </div>
  }

  @if (loading) {
    <div class="avatar__overlay avatar__overlay--loading">
      <span class="avatar__spinner" aria-hidden="true">⟳</span>
    </div>
  } @else if (editable) {
    <div class="avatar__overlay avatar__actions">
      <button type="button" class="avatar__action" (click)="onEdit($event)" [attr.aria-label]="'pages.profile.avatar.edit' | transloco">
        <i class="fas fa-camera" aria-hidden="true"></i>
      </button>
      @if (photo) {
        <button type="button" class="avatar__action avatar__action--danger" (click)="onRemove($event)" [attr.aria-label]="'pages.profile.avatar.remove' | transloco">
          <i class="fas fa-trash" aria-hidden="true"></i>
        </button>
      }
    </div>
  }
</div>
